import React from 'react';
import { Link } from 'react-router';
import styles from './style.css';

function BigNumberDisplay(props) {
  const { linkTo, title, content } = props;
  const deviceWidth = window.innerWidth > 0 ? window.innerWidth : screen.width;
  const colMdClass = deviceWidth > 1024 ? 'col-md-4' : 'col-md-6';
  return (
    <div className={`col-xs-12 col-sm-12 ${colMdClass}`}>
      <Link
        className={styles['linked-dashboard']}
        title="Click to see report!"
        to={linkTo}
      >
        <div className="sales-amount-box">
          <div className="title-center">{title}</div>
          <div className={styles['about-box']}>{content}</div>
        </div>
      </Link>
    </div>
  );
}

export default BigNumberDisplay;
